<template>
  <el-dialog :title="$t('borrowManage.add.title')" :visible.sync="visible" width="60%" @close="handleClose"
    :close-on-click-modal="false">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px" enctype="multipart/form-data">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('borrowManage.add.title')" prop="title">
            <el-input v-model="formData.title" :placeholder="$t('borrowManage.add.titlePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('borrowManage.add.typeCd')" prop="typeCd">
            <el-select v-model="formData.typeCd" :placeholder="$t('borrowManage.add.typeCdPlaceholder')" style="width:100%">
              <el-option v-for="item in borrowTypes" :key="item.typeCd" :label="item.typeName" :value="item.typeCd" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('borrowManage.add.headerImg')" prop="headerImg">
            <upload-image-url ref="uploadImage" :limitSize="1" :imageCount="1" @notifyUploadCoverImage="handleImageChange" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('borrowManage.add.quantity')" prop="quantity">
            <el-input v-model="formData.quantity" :placeholder="$t('borrowManage.add.quantityPlaceholder')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('borrowManage.add.unitPrice')" prop="unitPrice">
            <el-input v-model="formData.unitPrice" :placeholder="$t('borrowManage.add.unitPricePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('borrowManage.add.location')" prop="location">
            <el-input v-model="formData.location" :placeholder="$t('borrowManage.add.locationPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('borrowManage.add.context')" prop="context">
            <el-input v-model="formData.context" :placeholder="$t('borrowManage.add.context')" type="textarea" :rows="6"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveBorrow, listBorrowTypes } from '@/api/oa/borrowManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'

export default {
  name: 'AddBorrowView',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      visible: false,
      borrowTypes: [],
      formData: {
        title: '',
        typeCd: '',
        headerImg: '',
        context: '',
        quantity: '',
        unitPrice: '',
        location: '',
        communityId: ''
      },
      rules: {
        title: [
          { required: true, message: this.$t('borrowManage.validate.titleRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('borrowManage.validate.titleMaxLength'), trigger: 'blur' }
        ],
        typeCd: [
          { required: true, message: this.$t('borrowManage.validate.typeCdRequired'), trigger: 'change' }
        ],
        headerImg: [
          { required: true, message: this.$t('borrowManage.validate.headerImgRequired'), trigger: 'change' }
        ],
        context: [
          { required: false, message: this.$t('borrowManage.validate.contextRequired'), trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: this.$t('borrowManage.validate.quantityRequired'), trigger: 'blur' },
          { pattern: /^[0-9]*[1-9][0-9]*$/, message: this.$t('borrowManage.validate.quantityFormat'), trigger: 'blur' }
        ],
        unitPrice: [
          { required: false, message: this.$t('borrowManage.validate.unitPriceRequired'), trigger: 'blur' },
          { pattern: /^([1-9]\d*|0)(\.\d{1,2})?$/, message: this.$t('borrowManage.validate.unitPriceFormat'), trigger: 'blur' }
        ],
        location: [
          { required: false, message: this.$t('borrowManage.validate.locationRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async open() {
      this.visible = true
      this.formData.communityId = getCommunityId()
      await this._loadBorrowTypes()
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.$refs.uploadImage && this.$refs.uploadImage.clearImages()
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.$refs.uploadImage && this.$refs.uploadImage.clearImages()
    },
    async _loadBorrowTypes() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: getCommunityId()
        }
        const { data } = await listBorrowTypes(params)
        this.borrowTypes = data
      } catch (error) {
        console.error('获取借用类型失败:', error)
      }
    },
    handleImageChange(images) {
      this.formData.headerImg = images.length > 0 ? images[0] : ''
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveBorrow(this.formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.visible = false
            this.$emit('success')
          } catch (error) {
            this.$message.error(error.message || this.$t('common.operationFailed'))
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-textarea {
  width: 100%;
  min-height: 300px;
  padding: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  resize: vertical;
}
</style>